
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.02 18.83a.433.433 0 00.798-.336 12.441 12.441 0 01-.707-2.28 12.263 12.263 0 010-4.892 12.157 12.157 0 015.104-7.626 11.945 11.945 0 014.329-1.831c1.61-.328 3.27-.328 4.88 0 .779.162 1.54.4 2.273.707.224.097.44.2.65.304l-.967 1.55a.435.435 0 00.328.663l4.761.434h.04a.433.433 0 00.36-.675L20.27.943a.433.433 0 00-.727.01l-.737 1.185a14.049 14.049 0 00-.771-.364c-.786-.331-1.601-.585-2.435-.76a13.104 13.104 0 00-5.231 0A13.035 13.035 0 00.264 16.39c.174.835.427 1.652.757 2.44zM19.924 1.984l1.723 2.591-3.16-.288.855-1.367v-.003l.582-.933zM24.98 8.183a.433.433 0 00-.799.336c.308.735.545 1.498.707 2.278a12.255 12.255 0 010 4.889 12.149 12.149 0 01-5.103 7.62 11.947 11.947 0 01-4.329 1.83c-1.61.328-3.27.328-4.88 0-.778-.163-1.54-.4-2.273-.707-.224-.097-.439-.2-.649-.304l.966-1.548a.434.434 0 00-.327-.662l-4.762-.433a.433.433 0 00-.4.672l2.598 3.902c.08.121.215.194.36.194h.007a.433.433 0 00.36-.204l.736-1.183c.248.126.503.25.771.365.786.33 1.601.583 2.435.757 1.726.353 3.505.353 5.23 0A13.036 13.036 0 0025.737 15.86a13.13 13.13 0 000-5.24 13.371 13.371 0 00-.757-2.437zM6.077 25.017l-1.724-2.59 3.16.289-.854 1.366v.002l-.583.933z","fill":"#00E5FF"}})])
          )
        }
      }
    